import React from 'react';

const ModalPopup = (props) => {
return(
<div className={`modal fade ${props.className}`} id={`${props.id}`} aria-labelledby="termsCondition" aria-hidden="true">
    <div className="modal-dialog  modal-dialog-scrollable  modal-dialog-centered modal-lg">
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title" id="termsCondition">{props.modalTitle}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                {props.children}
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
);
}

export default ModalPopup;